import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Input, Typography, Upload, message } from "antd";
import ModalTags from "../GeoUnit/ModalTags";
import { context } from "../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const AdsFormStepOne = () => {
    const [form] = Form.useForm();
    // state
    const [isEditSelected, setIsEditSelected] = useState(false);
    const [dateRange, setDateRange] = useState([]);
    // context
    const {
        selectedAdId,
        setAdTags,
        adTitle,
        setAdTitle,
        setAdCover,
        setAdStartDate,
        adStartDate,
        setAdEndDate,
        adEndDate,
        adLink,
        setAdLink,
        adDescription,
        setAdDescription,
        adCover,
        adCoverId,
        setAdCoverId,
        setAdLimit,
        setAdNumOfSlide,
        setAdPosition,
        setAdPriority,
    } = useContext(context);
    // useEffect
    useEffect(() => {
        if (selectedAdId) {
            http.get(`${config.parkopoloApi}/api/Advertise/${selectedAdId}`)
                .then((res) => {
                    setAdTitle(res.data.result.title);
                    setAdTags(res.data.result.tags);
                    setAdLimit(res.data.result.limit);
                    setAdPosition(res.data.result.position);
                    setAdPriority(res.data.result.priority);
                    setAdNumOfSlide(res.data.result.numOfSlide);
                    setAdCover([res.data.result.coverPic]);
                    setAdStartDate(res.data.result.date.start);
                    setAdEndDate(res.data.result.date.end);
                    setAdDescription(res.data.result.description);
                    setAdLink(res.data.result.link);
                    setAdCoverId(res.data.result.coverPic._id);
                    setAdCover([
                        {
                            uid: adCoverId,
                            name: `${adCoverId}.png`,
                            status: "done",
                            url: res.data.result.coverPic.address,
                        },
                    ]);
                    setDateRange([
                        res.data.result.date.start,
                        res.data.result.date.end,
                    ]);
                })
                .catch((err) => {
                    console.log(err);
                });
            setIsEditSelected(true);
        } else {
            setDateRange([new Date(), new Date()]);
            setAdCoverId(null);
            setAdCover([
                {
                    uid: adCoverId,
                    name: "image.png",
                    status: "done",
                    url: null,
                },
            ]);
        }
    }, []);
    // functions
    const handleTitleChange = (e) => {
        setAdTitle(e.target.value);
    };
    const onUrlChange = (e) => {
        setAdLink(e.target.value);
    };
    const handleChangeDescription = (e) => {
        setAdDescription(e.target.value);
    };
    const handleChangeDate = (value) => {
        setAdStartDate(value[0]?.toDate?.().toString());
        setAdEndDate(value[1]?.toDate?.().toString());
        setDateRange(value);
    };
    const onChangeCover = (info) => {
        setAdCover(info.fileList);
        if (info.file.status === "done") {
            message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
            setAdCoverId(info.file.response.files[0]._id);
        } else if (info.file.status === "error") {
            message.error(` در آپلود فایل خطایی رخ داد!`);
        }
    };
    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };
    return (
        <div
            style={{
                direction: "rtl",
                display: "flex",
                gap: "15px",
                margin: "15px",
            }}
        >
            <Form
                layout="vertical"
                form={form}
                name="control-hooks"
                style={{
                    width: "100%",
                }}
            >
                <div style={{ display: "flex", gap: "2rem" }}>
                    <Form.Item
                        name="عنوان"
                        label="عنوان"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {adTitle}
                        </h4>
                        <Input
                            value={adTitle}
                            onChange={handleTitleChange}
                            placeholder="عنوان را وارد کنید"
                        />
                    </Form.Item>
                    <Form.Item
                        name="description"
                        label="توضیحات"
                        style={{ width: "100%" }}
                    >
                        {" "}
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {adDescription}
                        </h4>
                        <Input
                            value={adDescription}
                            onChange={handleChangeDescription}
                            placeholder="توضیخات را وارد کنید"
                        />
                    </Form.Item>
                </div>
                <div
                    style={{
                        display: "flex",
                        gap: "30px",
                        alignItems: "center",
                    }}
                >
                    <Form.Item
                        name="تاریخ"
                        label="تاریخ شروع و پایان"
                        style={{ width: "100%" }}
                    >
                        <div style={{ display: "none", gap: "2rem" }}>
                            <Typography.Paragraph>
                                {adStartDate}
                            </Typography.Paragraph>
                            <Typography.Paragraph>
                                {adEndDate}
                            </Typography.Paragraph>
                        </div>
                        <DatePicker
                            value={dateRange}
                            onChange={handleChangeDate}
                            range
                            dateSeparator=" تا "
                            plugins={[<DatePanel position="right" />]}
                            calendar={persian}
                            locale={persian_fa}
                            calendarPosition="bottom-right"
                        />
                    </Form.Item>
                    <Form.Item
                        name="آدرس لینک"
                        label="آدرس لینک"
                        style={{ width: "100%" }}
                    >
                        {" "}
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {adLink}
                        </h4>
                        <Input
                            value={adLink}
                            onChange={onUrlChange}
                            placeholder="آدرس لینک را وارد کنید"
                        />
                    </Form.Item>
                </div>
                <Form.Item name="تگ" label="تگ ها">
                    <div>
                        <ModalTags section="ads" />
                    </div>
                </Form.Item>
                <Form.Item name="cover" label="آپلود عکس">
                    <Upload
                        maxCount={1}
                        multiple={false}
                        name="objectKey"
                        action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65f56b50c5790f85cba41c61`}
                        listType="picture"
                        fileList={adCover}
                        onChange={onChangeCover}
                        onPreview={onPreview}
                    >
                        {adCover.length < 3 && (
                            <Button>+ آپلود عکس کاور</Button>
                        )}
                    </Upload>
                </Form.Item>
            </Form>
        </div>
    );
};

export default AdsFormStepOne;
